import { Grid2, TextField, Typography } from '@mui/material';

import { useTranslation } from 'react-i18next';

import { ConfirmationDialog } from 'app/components';
import { translations } from 'locales/i18n';

interface DenyDialogProps {
  open: boolean;
  handleClose: () => void;
  onConfirm: () => void;
  cancellationReason?: string | null;
  setCancellationReason: (cancellationReason: string) => void;
}

export const DenyDialog = ({
  open,
  handleClose,
  onConfirm,
  cancellationReason,
  setCancellationReason
}: DenyDialogProps) => {
  const { t } = useTranslation();
  return (
    <ConfirmationDialog
      open={open}
      onClose={handleClose}
      onConfirm={onConfirm}
      title={t(translations.pages.billing.dialogs.denyInvoiceTitle())}
    >
      <Grid2 container gap={2} flexDirection={'column'}>
        <Typography>{t(translations.pages.billing.dialogs.denyInvoiceMessage())}</Typography>
        <TextField
          size="small"
          value={cancellationReason}
          onChange={e => setCancellationReason(e.target.value)}
        />
      </Grid2>
    </ConfirmationDialog>
  );
};
